var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-menu"},[_c('div',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":{
        name: 'search'
      }}},[_c('img',{attrs:{"src":"/img/icons/icon-search.svg"}})])],1),_c('div',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":{
        name: 'map'
      }}},[_c('img',{attrs:{"src":"/img/icons/icon-map.svg"}})])],1),_c('div',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":{
        name: 'list'
      }}},[_c('img',{attrs:{"src":"/img/icons/icon-list.svg"}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }